import {useQueryState} from '@logistics-frontend/utils'
import {RangeValue} from '@react-types/shared'
import {memo, useCallback, useMemo} from 'react'

import {RangeDatePickerMobile} from './DatePicker@mobile'
import {QuerySyncedRangeDatePickerMobileProps, RangeDatePickerMobileProps} from './types'

export const QuerySyncedRangeDatePickerMobile = memo(
  ({queryName = {start: 'dateFrom', end: 'dateTo'}, ...props}: QuerySyncedRangeDatePickerMobileProps) => {
    const [dateFrom, setDateFrom] = useQueryState(queryName.start)
    const [dateTo, setDateTo] = useQueryState(queryName.end)

    const dateValue = useMemo(() => ({start: dateFrom, end: dateTo}), [dateFrom, dateTo])

    const handleChange: RangeDatePickerMobileProps['onChange'] = useCallback(
      (newValue: RangeValue<string | null>) => {
        setDateFrom(newValue.start)
        setDateTo(newValue.end)
      },
      [setDateFrom, setDateTo],
    )

    return <RangeDatePickerMobile {...props} onChange={handleChange} value={dateValue} />
  },
)
